<template>
<div class="edi-allorderbill">
	<navbar title="货品汇总-机构"></navbar>
	<div class="common-scroll" id="common-scroll">
		<div class="container">
			<!-- 机构、订货日期、编辑栏 -->
			<div class="goods-company-summary-base">
				<div class="goods-company-summary-left">
					<div><i class="goods-company-ico"></i><strong class="goods-company-name">{{restaurant_name}}</strong>
						<span v-if="bill_state === '10'" class="goods-company-status">未处理</span>
						<span v-if="bill_state === '11'" class="goods-company-status">待发货</span>
						<span v-if="bill_state === '12'" class="goods-company-status">已发货</span>
						<span v-if="bill_state === '13'" class="goods-company-status">已收货</span>
						<span v-if="bill_state === '14'" class="goods-company-status">已收货 已确认</span>
					</div>
					<strong class="goods-company-detail-name">{{goods_name}}</strong>
					<div class="lightblack-font">
						<span v-if="queryData.sort_method === '0' && queryData.bill_state !== 20 && queryData.bill_state !==21">订货日期：</span>
						<span v-if="queryData.sort_method === '0' && (queryData.bill_state === 20 || queryData.bill_state ===21)">退货日期：</span>
						<span v-if="queryData.sort_method === '1'">到货日期：</span>
						{{start_date}} 至 {{end_date}}
					</div>
				</div>
			</div>
			<div class="clear-float"></div>
			<!-- 明细条目栏 -->
			<div class="goods-company-summary-wrapper">
				<router-link v-for="billCount in billCounts" class="goods-company-detail-list" :to="{path: billCount.bill_state !==20 && billCount.bill_state !==21 ? '/all-order-bill' : 'all-return-bill', query: { bill_state: queryData.bill_state ,end_date: queryData.end_date, start_date: queryData.start_date, filterShow: false, sort_method: billCount.bill_state !==20 && billCount.bill_state !==21 ? '1' : '2', organ_id: queryData.organ_id, restaurant_id:queryData.restaurant_id, goods_id:queryData.goods_id, goods_unit: queryData.goods_unit}}">
					<strong class="goods-company-detail-name" v-if="billCount.bill_state ===20 || billCount.bill_state ===21">退货企业：{{queryData.restaurant_name}}</strong>
					<strong class="goods-company-detail-name" v-if="billCount.bill_state !==20 && billCount.bill_state !==21">订货：{{billCount.from_organ_name}}</strong>
					<strong class="goods-company-detail-name" v-else>退货机构：{{billCount.from_organ_name}}</strong>
					<strong class="goods-company-detail-name" v-if="billCount.bill_state !==20 && billCount.bill_state !==21">送往：{{billCount.to_organ_name}}</strong>
					<div class="goods-company-detail-show">
						<ul class="goods-company-detail-show-ul">
							<li v-if="billCount.bill_state === 20 || billCount.bill_state === 21">退：数量 {{billCount.goods_num}}</li>
							<li v-else>订：数量 {{billCount.goods_num}}</li>
							<li v-if="billCount.bill_state !==20 && billCount.bill_state !==21">含税金额：¥ {{billCount.sub_total}}</li>
							<li v-else>退货金额：¥ {{billCount.sub_total}}</li>
							<li v-if="bill_state === '12' | bill_state === '13' | bill_state === '14'">发：数量 {{billCount.goods_num_send}}</li>
							<li v-if="bill_state === '12' | bill_state === '13' | bill_state === '14'">含税金额：¥ {{billCount.sub_total_send}}</li>
							<li v-if="bill_state === '13' | bill_state === '14'">收：数量 {{billCount.goods_num_recipient}}</li>
							<li v-if="bill_state === '13' | bill_state === '14'">含税金额：¥ {{billCount.sub_total_recipient}}</li>
						</ul>
					</div>
					<div class="clear-float"></div>
				</router-link>
			</div>
		</div>
	</div>
	<get-total v-show="total" ref="cTotal" :filter="filterData" href="/cldEdi/business/getOrganInfoReportTotal" name="餐企"></get-total>
</div>
</template>
<script>
import BillCountFilter from '../components/BillCountFilter'
import GetTotal from '../components/GetGoodsTotal'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			total: false,
			loading: false,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			billCounts: null,
			show: true,
			cls: '',
			font: '',
			bill_state: '12,21',
			restaurant_id: '',
			organ_id: '',
			start_date: '',
			end_date: '',
			length: 10,
			start: 0,
			filterData: {},
			sec: 1500,
			prevLength: 0,
			restaurant_name: '',
			goods_name: '',
			store: GlobalStore,
			goodsTotalInfo: {}
		}
	},
	components: {
		'bill-filter': BillCountFilter,
		'get-total': GetTotal,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar
	},
	created () {
		/* var d = new Date()
		this.start_date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + '01'
		this.end_date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() */
		// window.console.log(this.queryData)
		this.store.goodsTotalInfo.filterShow = false
		this.goodsTotalInfo = this.store.goodsTotalInfo
		// window.console.log(this.goodsTotalInfo)
		this.organSearch()
	},
	methods: {
		onFilterOpen () {
			this.$refs.cTotal.close()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		refresh () {
			// 下拉刷新
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			if (marginBot === 0) {
				this.show = false
				if (this.prevLength < 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var billState = this.queryData.bill_state
				var restaurantId = this.queryData.restaurant_id
				var startDate = this.start_date
				var endDate = this.end_date
				this.filterData = {
					bill_state: billState,
					restaurant_id: restaurantId,
					start_date: startDate,
					end_date: endDate,
					start: start,
					length: 10
				}
				this.$http.post('/cldEdi/business/getTotalDetail', this.filterData).then((response) => {
					var data = response.body.data
					this.show = true
					this.prevLength = data.length
					this.billCounts = this.billCounts.concat(data)
					// window.console.log(this.billCounts)
				})
			}
		},
		organSearch () {
			this.midware = false
			this.total = false
			this.loading = true
			var billState = this.queryData.bill_state
			// var dateType = this.queryData.date_type
			var restaurantId = this.queryData.restaurant_id
			var organId = this.queryData.organ_id
			var startDate = this.queryData.start_date
			var endDate = this.queryData.end_date
			var goodsId = this.queryData.goods_id
			var sortMethod = this.queryData.sort_method
			var goodsUnit = this.queryData.goods_unit
			this.filterData = {
				restaurant_id: restaurantId,
				goods_id: goodsId,
				bill_state: billState,
				date_type: sortMethod,
				start_date: startDate,
				end_date: endDate,
				goods_unit: goodsUnit,
				length: this.length,
				start: this.start,
				fromOrganId: organId
			}
			// this.$router.push({path: '/bill-count', query: this.filterData})
			this.$http.post('/cldEdi/business/getOrganInfoReportDetail', this.filterData).then((response) => {
				this.loading = false
				// this.queryData = this.filterData
				var allInfo = response.body.data
				this.restaurant_name = allInfo.restaurant_name
				this.restaurant_id = allInfo.restaurant_id
				this.start_date = allInfo.startDate
				this.end_date = allInfo.endDate
				this.bill_state = allInfo.bill_state
				this.goods_name = allInfo.goods_name
				this.billCounts = response.body.data.details
				// window.console.log(this.billCounts)
				if (this.billCounts.length === undefined) {
					this.total = false
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				} else {
					this.total = true
				}
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
			// window.console.log(this.total)
		},
		getBackValue (msg) {
			var x = msg.split('|')
			this.queryData.restaurant_id = x[0]
			this.queryData.bill_state = x[1]
			this.restaurant_name = x[2]
		}
	}
}
</script>


// WEBPACK FOOTER //
// GoodsOrganSummary.vue?fcb8f438